"use client"
import CheckMark from "@/components/images/CheckMark";
import Close from "@/components/images/Close";
import { MouseEventHandler } from "react";
import styles from "./LocationButton.module.css";
import { type BygdekinoenLocation } from "@/sanity/sanity.types";

//#region [Props]
type LocationButtonProps = {
    location: BygdekinoenLocation;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    icon?: "checkmark" | "close";
};


//#endregion

//#region [Component]
export default function LocationButton({ location, onClick, icon = "close" }: LocationButtonProps) {
    return <button className={styles.LocationButton} onClick={onClick ? onClick : undefined}>{icon === "checkmark" && <CheckMark alt={location.poststed} />}{icon === "close" && <Close className={styles.Close} />}{location.location ?? location.name}</button>
}
//#endregion
